// @flow
import React, { type ComponentType, type ElementConfig } from 'react';
import { Trans } from '@lingui/react';
import styled, { type StyledComponent } from 'styled-components';

import CreditCardOptions from '../CreditCardOptions';
import Button from '../../../buttons/Button';

const Wrapper: ComponentType<{ disabled: boolean }> = styled.div`
  position: relative;
  text-align: right;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
`;

export const AddCardButton: StyledComponent<ElementConfig<typeof Button>, {}, any> = styled(Button)`
  margin-top: 8px;
`;

const DisabledOverlay: StyledComponent<{}> = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: not-allowed;
`;

export type Props = ElementConfig<typeof CreditCardOptions> & {
  onToggleForm: Function,
  className?: string,
  disabled: boolean,
};

const SelectCreditCardForm = ({ onToggleForm, className, disabled, ...other }: Props) => (
  <Wrapper className={className} disabled={disabled} data-qa-id="credit-card-forms-select-card">
    <CreditCardOptions {...other} />
    {disabled ? (
      <DisabledOverlay />
    ) : (
      <AddCardButton
        buttonType={Button.types.TEXT}
        onClick={onToggleForm}
        data-qa-id="credit-card-buttons-add"
      >
        <Trans>Add Credit Card</Trans>
      </AddCardButton>
    )}
  </Wrapper>
);

export default SelectCreditCardForm;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/CreditCardForm/SelectCreditCardForm/SelectCreditCardForm.jsx